import { render, staticRenderFns } from "./ModalVehiculo.vue?vue&type=template&id=57b1b51e"
import script from "./ModalVehiculo.vue?vue&type=script&lang=js"
export * from "./ModalVehiculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports